/* globals devex */

devex = devex || {};
devex.search = devex.search || {};

devex.search.Pagination = function (page, pageSize, total) {
  this.DEFAULT_PAGE_SIZE = 10;

  if (typeof page === 'undefined') {
    throw 'page is missing';
  }
  this.page = page;
  this.pageSize = pageSize || this.DEFAULT_PAGE_SIZE;
  this.total = total || 0;
};

/**
 * Returns the total number of pages based on `total` and `pageSize`.
 *
 * @returns {number}
 */
devex.search.Pagination.prototype.pageCount = function () {
  return Math.ceil(this.total / this.pageSize) || 1;
};

devex.search.Pagination.prototype.getParams = function (includePageSize) {
  var pageParams = {};
  if (this.page > 1) {
    pageParams.number = this.page;
  }
  if (includePageSize && this.pageSize !== this.DEFAULT_PAGE_SIZE) {
    pageParams.size = this.pageSize;
  }
  if (pageParams) {
    return {page: pageParams};
  } else {
    return {};
  }
};

devex.search.Pagination.prototype.setParams = function (params) {
  this.reset();
  this.page = params.page && params.page.number || 1;
  if (params.page && params.page.size) {
    this.pageSize = params.page.size;
  }
  this.total = params.total || 0;
};

devex.search.Pagination.prototype.reset = function () {
  this.page = 1;
  this.total = 0;
};

devex.search.Pagination.prototype.firstItemNumber = function () {
  return (this.page - 1) * this.pageSize + 1;
};

devex.search.Pagination.prototype.lastItemNumber = function () {
  var nr = this.page * this.pageSize;
  if (nr > this.total) {
    nr = this.total;
  }
  return nr;
};

/**
 * Get the number (1-based) of the item within all results. E.g. if this is the 3rd item on the 4th
 * page and the page size is 50, it actually is the 153rd item. Since the indices returned in the
 * code are zero-based, add one to the overall result.
 *
 * @param {number} indexOnPage - index of the item on the current page, 0 based
 * @returns {number} 1-based number of the result considering all results on previous pages
 */
devex.search.Pagination.prototype.overallItemNumber = function(indexOnPage) {
  var itemsBeforePage = (this.page - 1) * this.pageSize;
  return indexOnPage + 1 + itemsBeforePage;
};
